module.exports = __webpack_public_path__ + "static/media/APIStep1.dc571f6f.svg";